import type { ProductPageModelProps } from '@/components/product/product-page/product-page.model'
import { useProductPageModel } from '@/components/product/product-page/product-page.model'
import { ProductPageView } from '@/components/product/product-page/product-page.view'

export function ProductPageViewModel(props: ProductPageModelProps) {
  const model = useProductPageModel(props)
  return <ProductPageView {...model} />
}
